// Static site data — brand assets, contact, imagery
export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_38fd9250-debc-4672-ac8b-aeac6e1e6534/artifacts/253xhyku_ChatGPT%20Image%2014.%20Juni%202026%2C%2017_40_14.png";

// WhatsApp number for Kristian Y. — placeholder Swiss number, user can update
export const WHATSAPP_NUMBER = "41763770743"; // E.164 without "+" for wa.me
export const PHONE_DISPLAY = "+41 76 377 07 43";
export const EMAIL = "alphawatch.kristian@gmail.com";
export const ADDRESS_STREET = "Brandschenkestrasse 6";
export const ADDRESS_CITY = "8001 Zürich";

export const buildWhatsAppLink = (message) => {
  const encoded = encodeURIComponent(message || "");
  return `https://wa.me/${WHATSAPP_NUMBER}${encoded ? `?text=${encoded}` : ""}`;
};

export const IMAGES = {
  hero: "https://customer-assets.emergentagent.com/job_aw-atelier-zurich/artifacts/j7k8ni7w_a-lange-soehne-little-lange-1-moon-phase-182086-5.webp",
  hero_alt: "https://images.unsplash.com/photo-1639037687665-37cb1718fa30?q=80&w=2000",
  watch_service: "https://customer-assets.emergentagent.com/job_aw-atelier-zurich/artifacts/j7k8ni7w_a-lange-soehne-little-lange-1-moon-phase-182086-5.webp",
  goldsmith: "https://customer-assets.emergentagent.com/job_aw-atelier-zurich/artifacts/ys9lpp81_tahlia-doyle-uoUcwcRCSUI-unsplash.jpg",
  atelier: "https://customer-assets-gfyr7b9c.emergentagent.net/job_aw-atelier-zurich/artifacts/mk65b7ws_vanishing-point-images-v_m2UI6o_rE-unsplash.webp",
  zurich: "https://images.unsplash.com/photo-1531979089097-71d63a812a13?q=80&w=2000",
  gallery: [
    "https://images.pexels.com/photos/1137061/pexels-photo-1137061.jpeg",
    "https://images.pexels.com/photos/4276458/pexels-photo-4276458.jpeg",
    "https://images.unsplash.com/photo-1614103819260-337527876e87?q=80&w=1600",
    "https://images.unsplash.com/photo-1574525339177-193cfb19883b?q=80&w=1600",
    "https://images.unsplash.com/photo-1603563702614-312f2294c791?q=80&w=1600",
    "https://images.unsplash.com/photo-1639037687665-37cb1718fa30?q=80&w=1600",
    "https://images.unsplash.com/photo-1509048191080-d2984bad6ae5?q=80&w=1600",
    "https://images.unsplash.com/photo-1606760227091-3dd870d97f1d?q=80&w=1600",
    "https://images.unsplash.com/photo-1620625515032-6ed0c1790c75?q=80&w=1600",
  ],
};
